enum ReasonType {
  EMERGENCY = "emergency",
  NOTIFICATION = "notification",
}

export default ReasonType;
